import { getSubdomainFranchise } from '../utils/get-subdomain';
import { httpInterceptor } from './http.interceptor';

class FranchiseService {
  private subdomain: string;

  constructor() {
    this.subdomain = getSubdomainFranchise();
  }

  async findAllAvailable(): Promise<any> {
    try {
      const response = await httpInterceptor.get('/franchise/available', {
        headers: {
          'x-api-key': btoa('matriz'),
        }
      });
      return await response.json();
    } catch (erro) {
      throw erro;
    }
  }
}

export const franchiseService = new FranchiseService();
